import React from "react";
import {
    isMobile,
    isAndroid,
    isIOS,
} from "react-device-detect";

class Download extends React.Component {
    componentDidMount() {
        if (isMobile) {
            if(isIOS) {
                window.location.href = "https://apps.apple.com/us/app/lalert/id1596761949";
            }

            if(isAndroid) {
                window.location.href = "https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=com.lalert.global";
            }
        } else {
            alert("View Download Link From Mobile Phone");
        }
    }

    render() {
        return(
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center"}}>
                <h2 style={{ textAlign: "center", fontFamily: "monospace"}}>Downloading Lalert</h2>
            </div>
        );
    }
}

export default Download;